// pages/Unauthorized.jsx
const Unauthorized = () => (
  <div className="flex h-screen items-center justify-center bg-gray-50">
    <div className="rounded-2xl bg-white p-8 shadow-xl ring-1 ring-gray-200 text-center">
      <h1 className="text-xl font-bold text-red-600">Access denied</h1>
      <p className="mt-2 text-gray-600">You don’t have permission to view this page.</p>
    </div>
  </div>
);
export default Unauthorized;
